import { ReactElement, SVGProps } from 'react';

function SVGRight(props?: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.72 154.72" {...props}>
      <path fill="#00beb9" d="M154.72 17.73A17.74 17.74 0 00136.99 0H17.73A17.74 17.74 0 000 17.73v119.26a17.74 17.74 0 0017.73 17.73h119.26a17.74 17.74 0 0017.73-17.73zm-38.15 34.12a6.44 6.44 0 010 9.12l-41.9 41.9a6.44 6.44 0 01-9.12 0L44.6 81.92a6.45 6.45 0 119.11-9.12l16.4 16.4 37.34-37.35a6.44 6.44 0 019.12 0zm0 0"/>
    </svg>
  );
}

export default SVGRight;
